import HomePage from '../pages/HomePage';
import { ROUTES } from './routes.config';

export const MainRoutes = {
  path: ROUTES.HOME,
  element: <HomePage />,
};
